import { render, staticRenderFns } from "./RouterSearchBarComponent.vue?vue&type=template&id=4b7a7b8c&scoped=true"
import script from "./RouterSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./RouterSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./RouterSearchBarComponent.vue?vue&type=style&index=0&id=4b7a7b8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a7b8c",
  null
  
)

export default component.exports